import { render, staticRenderFns } from "./CategoryContents.vue?vue&type=template&id=568bdc51&scoped=true&"
import script from "./CategoryContents.vue?vue&type=script&lang=js&"
export * from "./CategoryContents.vue?vue&type=script&lang=js&"
import style0 from "./CategoryContents.vue?vue&type=style&index=0&id=568bdc51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568bdc51",
  null
  
)

export default component.exports